import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import FontResizer from '../../components/font-resizer/font-resizer';
import { Favorite, FavoriteType } from '../../model/favorite';
import FavoritesService from '../../services/favoritesService';
import { usePediatricDoseContext } from './pediatric-dose.provider';
import './pediatric-dose.scss';

interface Props extends RouteComponentProps<{}, {}, {}> {
    t: any;
}

const PediatricDoseHeader = (props: Props) => {
    const {
        fontSize,
        setFontSize,
        showAnnotation,
        showResizerModal,
        setShowAnnotation,
        setShowResizerModal,
        currentPediatricDose,
        setCurrentPediatricDose,
        showFavoriteSuccessToast,
        setShowFavoriteSuccessToast
    } = usePediatricDoseContext();

    const onFavorite = async (): Promise<void> => {
        const isFavorited = currentPediatricDose?.favorite?.isActive;
        const params: Favorite = {
            type: FavoriteType.PEDIATRIC_DOSE,
            pediatricDose: {
                id: currentPediatricDose?.id!
            },
            isActive: isFavorited ? false : undefined
        };
        setCurrentPediatricDose({ ...currentPediatricDose, favorite: { ...params, isActive: isFavorited ? false : true } });
        setShowFavoriteSuccessToast(!isFavorited);
        FavoritesService.favorite(params).then(() => {
            setTimeout(() => setShowFavoriteSuccessToast(false), 3000);
        });
    };

    return (
        <div className={'dose-header-container'}>
            <span className={'dose-header-name'}>{currentPediatricDose?.name ?? ''}</span>
            <div className={'dose-icons-container'}>
                <div className={'dose-header-medicine-button'} onClick={() => props.history.push(`/smart-bulas/${currentPediatricDose?.medicineLeaflet?.id}`)}>
                    <span className={'dose-header-medicine-button-text'}>{props.t('pediatricDose.seeMedicineLeaflet')}</span>
                </div>
                <div onClick={() => setShowAnnotation(!showAnnotation)} className={`dose-icon-pencil${currentPediatricDose?.note?.isActive ? '--on' : ''}`} />
                <div onClick={onFavorite} className={`dose-icon-favorite${currentPediatricDose?.favorite?.isActive ? '--on' : ''}`} />
                <div onClick={() => setShowResizerModal(!showResizerModal)} className={`dose-icon-font-resizer${showResizerModal ? '--on' : ''}`} />
            </div>
            {showResizerModal && (
                <div className="disease-content__slider-container" style={{ top: '194px', right: '26%' }}>
                    <FontResizer
                        changeFontSize={setFontSize}
                        fontSize={fontSize}
                    />
                </div>
            )}
            {showFavoriteSuccessToast && (
                <div className="disease-content__favorite-success-toast" style={{ top: '193px', right: '30.4vw' }}>
                    <div className="disease-content__white-star-img" />
                    <span className="disease-content__favorite-success-msg">{props.t('cid.favoriteSuccessMessage')}</span>
                </div>
            )}
        </div>
    );
}

const mapDispatchToProps = {};

export default compose(connect(null, mapDispatchToProps), withTranslation())(PediatricDoseHeader) as React.ComponentType<any>;
